<template>
  <nav class="app-topnav">
    <div class="container">
      <ul>
        <template v-if="profile.token">
          <li>
            <a href="javascript:;">
              <i class="iconfont icon-user"></i>{{ profile.nickName }}
            </a>
          </li>
          <li @click="logout"><a href="javascript:;">退出登录</a></li>
        </template>
        <template v-else>
          <li @click="visible = true">
            <a href="javascript:;">请先登录</a>
          </li>
          <li @click="visible = true"><a href="javascript:;">免费注册</a></li>
        </template>
        <li>
          <RouterLink target="_blank" to="/user/mine">我的订单</RouterLink>
        </li>
        <li>
          <RouterLink target="_blank" to="/user/mine">学习中心</RouterLink>
        </li>
        <li><a href="javascript:;">帮助中心</a></li>
        <li><RouterLink target="_blank" to="/about">关于我们</RouterLink></li>
        <li>
          <a href="javascript:;"><i class="iconfont icon-phone"></i>手机版</a>
        </li>
      </ul>
    </div>
  </nav>
  <el-dialog
    class="dialog"
    v-model="visible"
    :close-on-click-modal="false"
    align-center
    width="430"
  >
    <WeiLogin
      v-show="weilogin"
      @changePwd="changePwd"
      @changeCode="changeCode"
    />
    <PhoneLogin
      v-show="!weilogin"
      @changeWei="changeWei"
      @changeVisible="changeVisible"
      ref="childRef"
    />
  </el-dialog>
</template>

<script>
import WeiLogin from "../components/library/sh-weilogin.vue";
import PhoneLogin from "../components/library/sh-phonelogin.vue";
import { useStore } from "vuex";
import { computed, ref } from "vue";
export default {
  name: "AppTopnav",
  components: {
    WeiLogin,
    PhoneLogin,
  },
  setup() {
    const childRef = ref();
    const visible = ref(false);
    const weilogin = ref(true);
    const store = useStore();
    const profile = computed(() => {
      return store.state.user.profile;
    });
    const changePwd = () => {
      weilogin.value = !weilogin.value;
      childRef.value.weiToPwd();
    };
    const changeCode = () => {
      weilogin.value = !weilogin.value;
      childRef.value.weiToCode();
    };
    const changeWei = () => {
      weilogin.value = !weilogin.value;
    };

    //登录后关闭登录框
    const changeVisible = () => {
      visible.value = false;
    };
    //点击退出登录
    const logout = () => {
      localStorage.shweb = null;
      window.location.reload();
    };
    return {
      profile,
      visible,
      WeiLogin,
      PhoneLogin,
      changeWei,
      weilogin,
      changePwd,
      changeCode,
      childRef,
      changeVisible,
      logout,
    };
  },
};
</script>
<style lang="less">
.app-topnav {
  background: #585555;
  ul {
    display: flex;
    height: 30px;
    justify-content: flex-end;
    align-items: center;
    li {
      a {
        padding: 0 15px;
        color: #fff;
        line-height: 1;
        display: inline-block;
        i {
          font-size: 14px;
          margin-right: 2px;
        }
        &:hover {
          color: @shColor;
        }
      }
      ~ li {
        a {
          border-left: 2px solid #666;
        }
      }
    }
  }
}
.el-dialog {
  border-radius: 8px;
}
</style>
